/** @format */

import AxiosClient from "../AxiosClient";

export const getVar = (params) => {
  const url = `/api/var/searchInfoList`;
  return AxiosClient.post(url, params);
};

export const insertVar = (params) => {
  const url = "/api/var/insertInfo";
  return AxiosClient.post(url, params);
};

export const updateVar = (params) => {
  const url = "/api/var/updateInfo";
  return AxiosClient.post(url, params);
};


export const deleteVar = (params) => {
  const url = "/api/var/deleteInfo";
  return AxiosClient.post(url, params);
};
